<!-- snap素材上传入库 -->
<template>
  <div class="flex flex-wrap">
    <el-upload
      v-bind="$props"
      :file-list="value"
      :on-change="onChange"
      :auto-upload="false"
      ref="upload"
      class="mr-2 mb-2"
      v-show="value.length < limit"
      :limit="0"
    >
      <div class="leading-4 text-xs w-full h-full flex flex-col justify-center items-center">
        <div
          class="video-btm"
          @click.stop="handleMaterialLibraryClick"
        >
          <slot name="material-library-button"></slot>
        </div>
        <slot> </slot>
      </div>
    </el-upload>
    <div
      v-for="(file, index) in value"
      :key="file.uid"
      class="mr-4 upload-item-wrapper"
    >
      <el-upload
        v-bind="$props"
        :file-list="value"
        :on-change="onChange"
        :auto-upload="false"
        :http-request="uploadFile"
        disabled
        ref="showImg"
      >
        <!-- {{ file.mediaType }} -->
        <div
          class="relative w-full h-full leading-none box-border"
          :class="{
            'border-4': selectImgIndex == index,
            'border-primary': selectImgIndex == index,
          }"
          @click="$emit('update:selectImgIndex', selectImgIndex == index ? null : index)"
        >
          <img
            :src="file.url"
            class="w-full h-full block"
            v-if="file.mediaType == 'IMAGE'"
          />
          <video
            :src="file.url"
            class="w-full h-full block"
            v-if="file.mediaType == 'VIDEO'"
            controls
          />
          <div
            class="w-full video-btm"
            v-if="file.status == 'uploading'"
          >
            <el-progress
              :stroke-width="10"
              :percentage="file.process"
            ></el-progress>
          </div>
          <!-- 删除 -->
          <div class="absolute -right-2 -top-2 w-6 h-6 leading-none cursor-pointer z-20">
            <i
              class="el-icon-circle-close hover:text-primary"
              @click.stop="deleteItem(index)"
              v-if="isShowDelete"
            ></i>
          </div>
          <!-- 重新上传 -->
          <div
            class="z-10 absolute left-0 top-0 w-full h-full bg-white bg-opacity-75 bottom-0 right-0 m-auto flex flex-col justify-center items-center"
            v-if="file.status == 'fail'"
          >
            <div class="text-red-600 mt-3 text-base">
              <i class="el-icon-warning !text-red-600 !text-base"></i> 上传失败
            </div>
            <el-button
              size="mini"
              type="primary"
              @click.stop="uploadFile(file)"
              >重新上传</el-button
            >
          </div>
          <div
            class="z-10 absolute left-0 top-0 w-full h-full bg-white bg-opacity-75 bottom-0 right-0 m-auto flex flex-col justify-center items-center"
            v-if="file.status == 'ad-error'"
          >
            <div class="text-red-600 mt-3 text-base">
              <i class="el-icon-warning !text-red-600 !text-base"></i> 上传失败
            </div>
            <el-button
              size="mini"
              type="primary"
              @click.stop="uploadAdUrl(file, index)"
              >重新上传</el-button
            >
            {{ file.status }}
          </div>
          <div
            class="absolute right-3 w-[50px] h-6 leading-none cursor-pointer z-20"
            style="color: red;top: 100px;font-weight: bold;"
            v-if="(file.mediaOrigin === 'story' || file.mediaOrigin === 'spotlight' || file.mediaOrigin === 'assist') && file.failReason"
          >
            {{ file.failReason }}
          </div>
          <div style="text-align: left;color: #666666;" v-if="edit && platform === 'snapchat'">
            <div 
              style="margin-top: 10px;margin-bottom: 5px;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: flex;align-items: center;"
              :title="'hash: ' + file.hash"
            >
              <span style="flex: 1;">hash: {{ file.hash }}</span>
              <i class="el-icon-copy-document" style="cursor: pointer;margin-left: 5px;width: 14px;height: 14px;font-size: 14px;" @click.stop="copyToClipboard(file.hash)"></i>
            </div>
            <div 
              style="width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: flex;align-items: center;"
              :title="'seId: ' + file.seId"
            >
              <span style="flex: 1;">seId: {{ file.seId }}</span>
              <i class="el-icon-copy-document" style="cursor: pointer;margin-left: 5px;width: 14px;height: 14px;font-size: 14px;" @click.stop="copyToClipboard(file.seId)"></i>
            </div>
          </div>
        </div>
      </el-upload>
      <!-- 文件卡片底部插槽（紧贴卡片下方） -->
      <slot name="file-footer" :file="file" :index="index"></slot>
    </div>
  </div>
</template>

<script>
import { PropsType } from './index';
import GmUploadMaterial from './GmUploadMaterial.js';
// import { ts_md5_from_url } from '../../components/uploadMaterial/md5.js';
import { getFileExist } from '../../components/uploadMaterial/alioss';
import { postSaveAdFile } from '../../serve/material';
export default {
  mixins: [GmUploadMaterial],
  props: PropsType,
  data() {
    return {};
  },
  methods: {
    copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('复制成功');
        }).catch(() => {
          this.$message.error('复制失败');
        });
      } else {
        // Fallback for environments without clipboard API
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          this.$message.success('复制成功');
        } catch (err) {
          this.$message.error('复制失败');
        }
        document.body.removeChild(textArea);
      }
    },
    async uploadAdUrl(img, index) {
      try {
        this.setStatus(index, 'uploading');
        // const generatedMd5 = await ts_md5_from_url(img.url);
        const ext = (img.url.match(/\.(\w+)$/)?.[0] || '').replace('.', '');
        // const md5Value = generatedMd5.md5Value;
        const md5Value = img.hashcode || img.md5_code || img.md5;
        const fileRes = await getFileExist(md5Value, ext);
        if (!fileRes) {
          const params = {
            source: 2,
            isAgent: 0,
            fileData: [
              {
                ext: '.' + ext,
                file_name: md5Value + '.' + ext,
                file_size: img.size,
                md5_code: md5Value,
                play_time: '',
                url: img.url,
                uid: this.$store.state?.user?.userInfo?.data?.id,
              },
            ],
          };
          await postSaveAdFile(params);
          this.setStatus(index, 'success');
        } else {
          this.setStatus(index, 'success');
        }
      } catch (error) {
        this.setStatus(index, 'ad-error');
      }
    },
    setStatus(index, status) {
      this.$set(this.value, index, {
        ...this.value[index],
        status: status,
      });
    },
    handleMaterialLibraryClick(e) {
      if (this.$slots['material-library-button']) {
        e.preventDefault();
        e.stopPropagation();
        this.$emit('material-library-click');
      }
    },
    updateValue(list) {
      this.$emit('update:value', [...list]);
      this.$emit('change', list);
    },
    deleteItem(index) {
      this.value.splice(index, 1);
      this.updateValue(this.value);
    },
    onChange(file) {
      if (this.value.length >= this.limit) return;
      const uid = file.uid;
      const index = this.value.findIndex((item) => item.uid == uid);
      let list = this.value;
      if (index == -1) {
        let mediaType = file.raw.type.startsWith('image') ? 'IMAGE' : 'VIDEO';
        file.mediaType = mediaType;
        file.name = file.raw.name;
        list.push(file);
        this.updateValue(list);
      }
      this.selectLimit(file)
        .then(() => {
          setTimeout(() => {
            if (index >= 0) {
              list[index] = file;
              this.updateValue(list);
            } else {
              this.$nextTick(() => {
                this.uploadFile(file);
              });
            }
          }, 1000);
        })
        .catch((err) => {
          list = [...this.value];
          const i = list.findIndex((item) => item.uid == uid);
          if (i != -1) {
            list.splice(i, 1);
            this.updateValue(list);
          }
          this.$message.error(err);
        });
    },
    onProgress(event, file) {
      const uid = file.uid;
      const index = this.value.findIndex((item) => item.uid == uid);
      if (index >= 0) {
        // Calculate progress from loaded/total if percent not available
        const percent = event.percent || Math.round((event.loaded / event.total) * 100);
        this.value[index].process = percent;
        this.value[index].status = 'uploading';
        this.updateValue([...this.value]);
      }
    },
    async uploadFile(data) {
      const uid = data.uid;
      const index = this.value.findIndex((item) => item.uid === uid);
      if (index === -1) return;

      // Initialize upload state
      this.value[index].process = 0;
      this.value[index].status = 'uploading';
      this.updateValue([...this.value]);

      try {
        const res = await this.httpRequest(data.raw, {
          onUploadProgress: (e) => {
            this.onProgress(e, data);
          },
        });
        if (res && res.status === 'error') {
          throw new Error(res.message);
        }
        // Update to success state
        this.value[index] = {
          ...this.value[index],
          ...res,
          url: res.url,
          originalFilename: res.name,
          status: 'success',
          process: 100,
        };
        this.updateValue([...this.value]);
      } catch (err) {
        // Update to error state
        this.value[index].status = 'fail';
        this.value[index].process = null;
        this.updateValue([...this.value]);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.video-btm {
  margin-bottom: 30px;
}
.upload-item-wrapper {
  margin-bottom: 10px;

  .el-upload--picture-card {
    margin-bottom: 0;
  }
}
</style>